






// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default ( Chatbot: any ) => {
	return class Dad_Joke_Bot extends Chatbot {
		readonly name = 'Dad Joke Bot';
		readonly avatar = 'dad-bot';
		readonly description = 'Dad jokes are very punny.';
		
		async getContent() {
			const request = await fetch('https://icanhazdadjoke.com/', {
				headers: {
					Accept: 'application/json'
				}
			})
			const data = await request.json();
			return data.joke;
		}
	
	}
}

